import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Phase 2 stub for the future right-hand agent panel toggle.
 * Disabled icon-button with a tooltip describing the upcoming agent
 * (per `docs/frontend/ui-spec.md` §5.3). Real toggle + panel land in Phase 3.
 */
export function AgentToggleStub(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-disabled="true"
          data-testid="agent-toggle-stub"
          aria-label={t("layout.agentStub.aria")}
          onClick={(event) => event.preventDefault()}
          className="text-muted-foreground cursor-not-allowed hover:bg-transparent hover:text-muted-foreground"
        >
          <Sparkles className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end" className="max-w-xs whitespace-normal">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold">{t("layout.agentStub.title")}</span>
          <span className="text-xs leading-snug opacity-90">{t("layout.agentStub.body")}</span>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
